import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { MdOutlineLibraryBooks } from "react-icons/md";
import { IoIosArrowRoundBack } from 'react-icons/io';

const ExamView = () => {
    useEffect(() => {
        window.scrollTo(0, 0);
      }, []);
    
    return (
        <>
            <div className='container-fluid every_page_mg_top'>
                <div className='row' style={{ backgroundColor: "#F8F9FA" }}>
                    <div className="col-md-1"></div>
                    <div className="col-md-5 mt-5 p-3" style={{ display: "flex", flexDirection: 'column', gap: "10px" }}>
                        <h2>Preparing For MCA Entrance</h2>
                        <p>NIMCET, MCA JNU, MCA BHU, MAH CET MCA, MCA UPSEE, TANCET, MCA DU</p>
                        <h5>You are at the right platform.</h5>
                        <div><Link to="/signin"><button className='exercise_login_btn'>Login</button></Link>
                            <button className='exercise_login_btn'>Create a new account</button></div>
                    </div>
                    <div className="col-md-6">
                        <div className='design_view'>
                            <h3>NIMCET Test Series</h3>
                            <p>Get access to all premium mock papers (Topic wise + Subject wise + Full length mock Papers)
                                <br /><br />
                                Complete Solution, Detailed Result Analysis, All India Rank, Multiple Attempts, WhatsApp Support</p><br/>
                                <button className='exercise_login_btn'>Join Now</button>
                        </div>
                    </div>
                </div>
            </div>
            <div className="container">
                <div className='row quiz_list p-5'>
                <div className="row"><Link to="/quiz-list"><IoIosArrowRoundBack className='back_arrow'/></Link></div><br/><br/>
                    <div className="col-md-2 single_quiz_list">
                        <MdOutlineLibraryBooks style={{ fontSize: '50px' }} />
                        <Link to="/ExamDetails" className='single_quiz_list_link'>Exam's Detail</Link>
                    </div>
                    <div className="col-md-2 single_quiz_list">
                        <MdOutlineLibraryBooks style={{ fontSize: '50px' }} />
                        <Link to="/Syllabus" className='single_quiz_list_link'>Syllabus</Link>
                    </div>
                    <div className="col-md-2 single_quiz_list">
                        <MdOutlineLibraryBooks style={{ fontSize: '50px' }} />
                        <Link to="/PreviousYearQuiz" className='single_quiz_list_link' style={{whiteSpace: "nowrap"}}>Previous Year  Que</Link>
                    </div>
                    <div className="col-md-2 single_quiz_list">
                        <MdOutlineLibraryBooks style={{ fontSize: '50px' }} />
                        <Link to="/Notification" className='single_quiz_list_link'>Notification</Link>
                    </div>
                    <div className="col-md-2 single_quiz_list">
                        <MdOutlineLibraryBooks style={{ fontSize: '50px' }} />
                        <Link to="/start-quiz/HTML" className='single_quiz_list_link'>Take Test</Link>
                    </div>

                </div>
            </div>
        </>
    );
};

export default ExamView;

